/* 👻🚨👻🚨👻 Let op! This code has been auto generated, so best not to touch it 👻🚨👻🚨👻 */
import * as Types from '../types';

import type { FetchOptions } from "../fetcher/fetcher.types"
import { useQuery, useSuspenseQuery, useInfiniteQuery, useSuspenseInfiniteQuery, useMutation, UseQueryOptions, UseSuspenseQueryOptions, UseInfiniteQueryOptions, InfiniteData, UseSuspenseInfiniteQueryOptions, UseMutationOptions } from '@tanstack/react-query';
import { fetcher } from '../fetcher/index';
export type StudioIsTemplateFavoritedQueryVariables = Types.Exact<{
  templateId: Types.Scalars['ID']['input'];
}>;


export type StudioIsTemplateFavoritedQuery = { __typename?: 'Query', publishedTemplatesFavorited: { __typename?: 'PublishedTemplatesFavoritedResponse', favorited: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type StudioAddFavoriteTemplateMutationVariables = Types.Exact<{
  templateId: Types.Scalars['ID']['input'];
}>;


export type StudioAddFavoriteTemplateMutation = { __typename?: 'Mutation', publishedTemplatesAddFavorite: { __typename?: 'PublishedTemplatesAddFavoriteResponse', success: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type StudioRemoveFavoriteTemplateMutationVariables = Types.Exact<{
  templateId: Types.Scalars['ID']['input'];
}>;


export type StudioRemoveFavoriteTemplateMutation = { __typename?: 'Mutation', publishedTemplatesRemoveFavorite: { __typename?: 'PublishedTemplatesRemoveFavoriteResponse', success: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type StudioTemplatesFavoritesListQueryVariables = Types.Exact<{
  input: Types.PublishedTemplatesListFavoritesInput;
}>;


export type StudioTemplatesFavoritesListQuery = { __typename?: 'Query', publishedTemplatesListFavorites: { __typename?: 'PublishedTemplatesListFavoritesResponse', pagination?: { __typename?: 'PublishedTemplatesPagination', totalPages: number } | null, templates?: Array<{ __typename?: 'PublishedTemplate', id: string }> | null } };



export const StudioIsTemplateFavoritedDocument = /*#__PURE__*/ `
    query studioIsTemplateFavorited($templateId: ID!) {
  publishedTemplatesFavorited(input: {templateId: $templateId}) {
    favorited
    errors {
      code
      message
    }
  }
}
    `;

export const useStudioIsTemplateFavoritedQuery = <
      TData = StudioIsTemplateFavoritedQuery,
      TError = unknown
    >(
      variables: StudioIsTemplateFavoritedQueryVariables,
      options?: Omit<UseQueryOptions<StudioIsTemplateFavoritedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<StudioIsTemplateFavoritedQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useQuery<StudioIsTemplateFavoritedQuery, TError, TData>(
      {
    queryKey: ['studioIsTemplateFavorited', variables],
    queryFn: fetcher<StudioIsTemplateFavoritedQuery, StudioIsTemplateFavoritedQueryVariables>(StudioIsTemplateFavoritedDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useStudioIsTemplateFavoritedQuery.document = StudioIsTemplateFavoritedDocument;

useStudioIsTemplateFavoritedQuery.getKey = (variables: StudioIsTemplateFavoritedQueryVariables) => ['studioIsTemplateFavorited', variables];

useStudioIsTemplateFavoritedQuery.rootKey = 'studioIsTemplateFavorited';

export const useSuspenseStudioIsTemplateFavoritedQuery = <
      TData = StudioIsTemplateFavoritedQuery,
      TError = unknown
    >(
      variables: StudioIsTemplateFavoritedQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<StudioIsTemplateFavoritedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<StudioIsTemplateFavoritedQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useSuspenseQuery<StudioIsTemplateFavoritedQuery, TError, TData>(
      {
    queryKey: ['studioIsTemplateFavoritedSuspense', variables],
    queryFn: fetcher<StudioIsTemplateFavoritedQuery, StudioIsTemplateFavoritedQueryVariables>(StudioIsTemplateFavoritedDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useSuspenseStudioIsTemplateFavoritedQuery.document = StudioIsTemplateFavoritedDocument;

useSuspenseStudioIsTemplateFavoritedQuery.getKey = (variables: StudioIsTemplateFavoritedQueryVariables) => ['studioIsTemplateFavoritedSuspense', variables];

useSuspenseStudioIsTemplateFavoritedQuery.rootKey = 'studioIsTemplateFavorited';

export const useInfiniteStudioIsTemplateFavoritedQuery = <
      TData = InfiniteData<StudioIsTemplateFavoritedQuery>,
      TError = unknown
    >(
      variables: StudioIsTemplateFavoritedQueryVariables,
      options: Omit<UseInfiniteQueryOptions<StudioIsTemplateFavoritedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<StudioIsTemplateFavoritedQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<StudioIsTemplateFavoritedQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['studioIsTemplateFavorited.infinite', variables],
      queryFn: (metaData) => fetcher<StudioIsTemplateFavoritedQuery, StudioIsTemplateFavoritedQueryVariables>(StudioIsTemplateFavoritedDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteStudioIsTemplateFavoritedQuery.getKey = (variables: StudioIsTemplateFavoritedQueryVariables) => ['studioIsTemplateFavorited.infinite', variables];

useInfiniteStudioIsTemplateFavoritedQuery.rootKey = 'studioIsTemplateFavorited.infinite';

export const useSuspenseInfiniteStudioIsTemplateFavoritedQuery = <
      TData = InfiniteData<StudioIsTemplateFavoritedQuery>,
      TError = unknown
    >(
      variables: StudioIsTemplateFavoritedQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<StudioIsTemplateFavoritedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<StudioIsTemplateFavoritedQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<StudioIsTemplateFavoritedQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['studioIsTemplateFavorited.infiniteSuspense', variables],
      queryFn: (metaData) => fetcher<StudioIsTemplateFavoritedQuery, StudioIsTemplateFavoritedQueryVariables>(StudioIsTemplateFavoritedDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteStudioIsTemplateFavoritedQuery.getKey = (variables: StudioIsTemplateFavoritedQueryVariables) => ['studioIsTemplateFavorited.infiniteSuspense', variables];

useSuspenseInfiniteStudioIsTemplateFavoritedQuery.rootKey = 'studioIsTemplateFavorited.infinite';


useStudioIsTemplateFavoritedQuery.fetcher = (variables: StudioIsTemplateFavoritedQueryVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<StudioIsTemplateFavoritedQuery, StudioIsTemplateFavoritedQueryVariables>(StudioIsTemplateFavoritedDocument, variables, options, fetchOptions);

export const StudioAddFavoriteTemplateDocument = /*#__PURE__*/ `
    mutation studioAddFavoriteTemplate($templateId: ID!) {
  publishedTemplatesAddFavorite(input: {templateId: $templateId}) {
    success
    errors {
      code
      message
    }
  }
}
    `;

export const useStudioAddFavoriteTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<StudioAddFavoriteTemplateMutation, TError, StudioAddFavoriteTemplateMutationVariables, TContext>, headers?: Headers, fetchOptions?: FetchOptions) => {
    
    return useMutation<StudioAddFavoriteTemplateMutation, TError, StudioAddFavoriteTemplateMutationVariables, TContext>(
      {
    mutationKey: ['studioAddFavoriteTemplate'],
    mutationFn: (variables?: StudioAddFavoriteTemplateMutationVariables) => fetcher<StudioAddFavoriteTemplateMutation, StudioAddFavoriteTemplateMutationVariables>(StudioAddFavoriteTemplateDocument, variables, headers, fetchOptions)(),
    ...options
  }
    )};

useStudioAddFavoriteTemplateMutation.getKey = () => ['studioAddFavoriteTemplate'];


useStudioAddFavoriteTemplateMutation.fetcher = (variables: StudioAddFavoriteTemplateMutationVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<StudioAddFavoriteTemplateMutation, StudioAddFavoriteTemplateMutationVariables>(StudioAddFavoriteTemplateDocument, variables, options, fetchOptions);

export const StudioRemoveFavoriteTemplateDocument = /*#__PURE__*/ `
    mutation studioRemoveFavoriteTemplate($templateId: ID!) {
  publishedTemplatesRemoveFavorite(input: {templateId: $templateId}) {
    success
    errors {
      code
      message
    }
  }
}
    `;

export const useStudioRemoveFavoriteTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<StudioRemoveFavoriteTemplateMutation, TError, StudioRemoveFavoriteTemplateMutationVariables, TContext>, headers?: Headers, fetchOptions?: FetchOptions) => {
    
    return useMutation<StudioRemoveFavoriteTemplateMutation, TError, StudioRemoveFavoriteTemplateMutationVariables, TContext>(
      {
    mutationKey: ['studioRemoveFavoriteTemplate'],
    mutationFn: (variables?: StudioRemoveFavoriteTemplateMutationVariables) => fetcher<StudioRemoveFavoriteTemplateMutation, StudioRemoveFavoriteTemplateMutationVariables>(StudioRemoveFavoriteTemplateDocument, variables, headers, fetchOptions)(),
    ...options
  }
    )};

useStudioRemoveFavoriteTemplateMutation.getKey = () => ['studioRemoveFavoriteTemplate'];


useStudioRemoveFavoriteTemplateMutation.fetcher = (variables: StudioRemoveFavoriteTemplateMutationVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<StudioRemoveFavoriteTemplateMutation, StudioRemoveFavoriteTemplateMutationVariables>(StudioRemoveFavoriteTemplateDocument, variables, options, fetchOptions);

export const StudioTemplatesFavoritesListDocument = /*#__PURE__*/ `
    query studioTemplatesFavoritesList($input: PublishedTemplatesListFavoritesInput!) {
  publishedTemplatesListFavorites(input: $input) {
    pagination {
      totalPages
    }
    templates {
      id
    }
  }
}
    `;

export const useStudioTemplatesFavoritesListQuery = <
      TData = StudioTemplatesFavoritesListQuery,
      TError = unknown
    >(
      variables: StudioTemplatesFavoritesListQueryVariables,
      options?: Omit<UseQueryOptions<StudioTemplatesFavoritesListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<StudioTemplatesFavoritesListQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useQuery<StudioTemplatesFavoritesListQuery, TError, TData>(
      {
    queryKey: ['studioTemplatesFavoritesList', variables],
    queryFn: fetcher<StudioTemplatesFavoritesListQuery, StudioTemplatesFavoritesListQueryVariables>(StudioTemplatesFavoritesListDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useStudioTemplatesFavoritesListQuery.document = StudioTemplatesFavoritesListDocument;

useStudioTemplatesFavoritesListQuery.getKey = (variables: StudioTemplatesFavoritesListQueryVariables) => ['studioTemplatesFavoritesList', variables];

useStudioTemplatesFavoritesListQuery.rootKey = 'studioTemplatesFavoritesList';

export const useSuspenseStudioTemplatesFavoritesListQuery = <
      TData = StudioTemplatesFavoritesListQuery,
      TError = unknown
    >(
      variables: StudioTemplatesFavoritesListQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<StudioTemplatesFavoritesListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<StudioTemplatesFavoritesListQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useSuspenseQuery<StudioTemplatesFavoritesListQuery, TError, TData>(
      {
    queryKey: ['studioTemplatesFavoritesListSuspense', variables],
    queryFn: fetcher<StudioTemplatesFavoritesListQuery, StudioTemplatesFavoritesListQueryVariables>(StudioTemplatesFavoritesListDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useSuspenseStudioTemplatesFavoritesListQuery.document = StudioTemplatesFavoritesListDocument;

useSuspenseStudioTemplatesFavoritesListQuery.getKey = (variables: StudioTemplatesFavoritesListQueryVariables) => ['studioTemplatesFavoritesListSuspense', variables];

useSuspenseStudioTemplatesFavoritesListQuery.rootKey = 'studioTemplatesFavoritesList';

export const useInfiniteStudioTemplatesFavoritesListQuery = <
      TData = InfiniteData<StudioTemplatesFavoritesListQuery>,
      TError = unknown
    >(
      variables: StudioTemplatesFavoritesListQueryVariables,
      options: Omit<UseInfiniteQueryOptions<StudioTemplatesFavoritesListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<StudioTemplatesFavoritesListQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<StudioTemplatesFavoritesListQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['studioTemplatesFavoritesList.infinite', variables],
      queryFn: (metaData) => fetcher<StudioTemplatesFavoritesListQuery, StudioTemplatesFavoritesListQueryVariables>(StudioTemplatesFavoritesListDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteStudioTemplatesFavoritesListQuery.getKey = (variables: StudioTemplatesFavoritesListQueryVariables) => ['studioTemplatesFavoritesList.infinite', variables];

useInfiniteStudioTemplatesFavoritesListQuery.rootKey = 'studioTemplatesFavoritesList.infinite';

export const useSuspenseInfiniteStudioTemplatesFavoritesListQuery = <
      TData = InfiniteData<StudioTemplatesFavoritesListQuery>,
      TError = unknown
    >(
      variables: StudioTemplatesFavoritesListQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<StudioTemplatesFavoritesListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<StudioTemplatesFavoritesListQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<StudioTemplatesFavoritesListQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['studioTemplatesFavoritesList.infiniteSuspense', variables],
      queryFn: (metaData) => fetcher<StudioTemplatesFavoritesListQuery, StudioTemplatesFavoritesListQueryVariables>(StudioTemplatesFavoritesListDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteStudioTemplatesFavoritesListQuery.getKey = (variables: StudioTemplatesFavoritesListQueryVariables) => ['studioTemplatesFavoritesList.infiniteSuspense', variables];

useSuspenseInfiniteStudioTemplatesFavoritesListQuery.rootKey = 'studioTemplatesFavoritesList.infinite';


useStudioTemplatesFavoritesListQuery.fetcher = (variables: StudioTemplatesFavoritesListQueryVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<StudioTemplatesFavoritesListQuery, StudioTemplatesFavoritesListQueryVariables>(StudioTemplatesFavoritesListDocument, variables, options, fetchOptions);
